module.exports = __webpack_public_path__ + "img/pic_goldenfollowers_differences.ba94145d.png";